import { DocumentServicesObject } from '@wix/document-services-types';
import { EditorEventHandlers } from './handlers';
import { handleTPAMessage } from './common/SdkPostMessageCommon';
import { SdkEvent, TPAMessage } from './types/tpaMessage';
import { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';
import { validateHandlerAccess } from './intentAccessControl';

interface SdkEventHandlerServiceMethods {
  initializeListenerHandlers: () => void;
}

export const SdkEventHandlerService = (
  listenerMethod: Window['addEventListener'],
  handlers: EditorEventHandlers,
  documentServicesAPI: DocumentServicesObject,
  platformApiMethods: PlatformApiMethods,
): SdkEventHandlerServiceMethods => {
  const getEventHandler = (msg: TPAMessage) => {
    // TODO check if we need to support specific case with santa's editorSettingsModalHandlers -> resizeWindow
    return handlers[msg.type];
  };

  const setSelectedComponentIdToMessage = async (msg: TPAMessage) => {
    const [selectedComponent] =
      await platformApiMethods.editor.selection.getSelectedComponents();

    if (selectedComponent) {
      if (msg.compId) {
        msg.senderCompId = msg.compId;
      }
      msg.compId = selectedComponent.id;
    }
  };

  const callHandler = async (msg: TPAMessage, response: any) => {
    const handler = getEventHandler(msg);

    const validation = validateHandlerAccess(msg.intent, msg.type);

    if (!validation.isAllowed) {
      throw new Error(validation.error);
    }

    await setSelectedComponentIdToMessage(msg);

    if (handler) {
      handler.call(null, msg, response);
      // @ts-expect-error
      documentServicesAPI.tpa.bi.sendBIEvent(msg, 'editor');
    } else {
      // @ts-expect-error
      documentServicesAPI.tpa.handlers(
        {
          ...msg,
          originFrame: 'editor',
        },
        response,
      );
    }
  };

  const initializeListenerHandlers = () => {
    listenerMethod(
      'message',
      (event: MessageEvent<SdkEvent>) =>
        handleTPAMessage(callHandler, event as SdkEvent),
      false,
    );
  };

  return {
    initializeListenerHandlers,
  };
};
